import { render, staticRenderFns } from "./PostCostWorkOrders.vue?vue&type=template&id=1145d48c&scoped=true&"
import script from "./PostCostWorkOrders.vue?vue&type=script&lang=js&"
export * from "./PostCostWorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./PostCostWorkOrders.vue?vue&type=style&index=0&id=1145d48c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1145d48c",
  null
  
)

export default component.exports